import React from 'react'
import { connect } from 'react-redux';
import {
  changePage
} from '../../../action/VodAction';
import Genre from '../genre/genre'
import MovieLanguage from './movieLanguages'

class MovieByLanguage extends React.Component {
  goBack = () => {
    this.props.changePage(1);
  }
  getSubInLang = () => {
    let flag = false, langObj = null
    if (this.props.languageOrder) {
      this.props.languageOrder.map((iterator, index) => {
        if (this.props.currentLang === iterator.name) {
          flag = true
          langObj = iterator
        }
      })
    }
    if (!flag) {
      return <MovieLanguage />
    } else {
     // console.log("@@ langOBJ", langObj);
      return <Genre />
    }
  }
  render() {
    return (
      <div>
        {this.getSubInLang()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    currentLang: state.store.vod.lang.currentLang,
    languageOrder: state.store.vod.VODData ?
      state.store.vod.VODData.channelLanguageOrder : null
  }
}

export default connect(
  mapStateToProps, {
    changePage
  }
)(MovieByLanguage);